import { z } from "zod";
import { CustomFormFieldValidation } from "@shared/types";
import { masks } from "@core/utils/masks";

interface CustomValidations {
  cpf: CustomFormFieldValidation;
}

export const subscriptionSchema = ({ cpf }: CustomValidations) => {
  return z.object({
    user: z.number().optional().nullable(),
    cpf: z.string()
      .optional()
      .nullable()
      .transform((value) => value ? masks.unmask(value) : null)
      .refine(
        (value) => value ? cpf.validate(value) : true,
        { message: cpf.errorMessage }
      ),
    plan: z.union([z.number(), z.array(z.number()).min(1)]),
    start_date: z
      .any()
      .transform((date) => {
        if (!date) return null;
        if (typeof date === "string") return date;

        const isoString = date.toISOString();
        return isoString.split("T")[0];
      })
      .optional()
      .nullable(),
    valid_until: z
      .any()
      .transform((date) => {
        if (!date) return null;
        if (typeof date === "string") return date;

        const isoString = date.toISOString();
        return isoString.split("T")[0];
      })
      .optional()
      .nullable(),
    active: z.boolean().nullable(),
  }).refine((data) => data.user || data.cpf, {
    message: "Usuário ou CPF são obrigatórios",
    path: ["user"]
  });
};

export type SubscriptionFormValues = z.infer<ReturnType<typeof subscriptionSchema>>;
